<section class="p-hero">
  <img class="p-hero__img" [src]="heroSrc" alt="" />
  <div class="p-hero__shade" aria-hidden="true"></div>

  <div class="container p-hero__content">
    <div class="p-hero__card glass">
      <h1 class="p-hero__title">{{ 'products.demoTitle' | translate }}</h1>
      <p class="p-hero__lead">{{ 'products.demoP1' | translate }}</p>
      <p class="p-hero__lead">{{ 'products.demoP2' | translate }}</p>
    </div>
  </div>
</section>

<section class="container p-section">
  <div class="p-split glass">
    <div class="p-split__media">
      <img class="p-split__img" [src]="biopolymerSrc" [alt]="'products.images.demoAlt' | translate" />
    </div>
    <div class="p-split__content">
      <h2 class="p-h2">{{ 'products.blocks.qualityTitle' | translate }}</h2>
      <p class="p-body">{{ 'products.blocks.qualityBody' | translate }}</p>
    </div>
  </div>
</section>

<section class="container p-section">
  <header class="p-head">
    <h2 class="p-h2">{{ 'products.bannerTitle' | translate }}</h2>
    <p class="p-sub">{{ 'products.bannerMeta' | translate }}</p>
  </header>

  <div class="p-grid">
    <article class="p-card glass">
      <h3 class="p-card__title">{{ 'products.blocks.qualityTitle' | translate }}</h3>
      <p class="p-card__body">{{ 'products.blocks.qualityBody' | translate }}</p>
    </article>

    <article class="p-card glass">
      <h3 class="p-card__title">{{ 'products.blocks.portfolioTitle' | translate }}</h3>
      <p class="p-card__body">{{ 'products.blocks.portfolioBody' | translate }}</p>
    </article>

    <article class="p-card glass">
      <h3 class="p-card__title">{{ 'products.blocks.applicationsTitle' | translate }}</h3>
      <p class="p-card__body">{{ 'products.blocks.applicationsBody' | translate }}</p>
    </article>
  </div>

  <div class="p-banner glass">
    <img class="p-banner__img" [src]="packagingSrc" [alt]="'products.images.demoAlt' | translate" />
    <div class="p-banner__shade" aria-hidden="true"></div>
    <div class="p-banner__content">
      <h3 class="p-banner__title">{{ 'products.bannerTitle' | translate }}</h3>
      <p class="p-banner__body">{{ 'products.bannerBody' | translate }}</p>
    </div>
  </div>
</section>

